export default function () {
  if (document.querySelector('#form_bigteam')) {
    // eslint-disable-next-line no-unused-expressions
    import(
      /* webpackChunkName: "bigteam" */ '../_03_organisms/bigteam/form'
    );
  }
}
